import { CommonModule } from "@angular/common";
import { NgModule, ModuleWithProviders } from "@angular/core";

import { CountdownComponent } from "./components/component";
import { Timer } from "./components/timer";

@NgModule({
    imports: [CommonModule],
    declarations: [CountdownComponent],
    exports: [CountdownComponent]
})
export class AdCountDownModule {
    static forRoot(): ModuleWithProviders {
        return { ngModule: AdCountDownModule, providers: [Timer] };
    }
}
